import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/observatories/';
    const pathsList = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'governanceroom/observatories/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/observatories/delete`
    }

    const list = {
        labelTitle: 'Lista de Observatórios',
        labelTitleButtonAdd: 'Incluir novo observatório',
        fieldsShowOnDelete: ['name'],
        filter: profileFilter,
        canDelete: true,
        columns: [
            {
                name: 'name',
                label: 'Observatório'
            },
            {
                name: 'client',
                label: 'Cliente'
            }
        ],
        ...pathsList
    };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;